<template>
	<button
		:name="name"
		:class="{
			selected: selected
		}"
		@mousedown.prevent
	>
		<slot></slot>
	</button>
</template>
<script>
export default {
	props: {
		name: {
			type: String,
			required: true
		},
		selected: {
			type: Boolean,
			default: false
		}
	}
};
</script>
<style lang="scss" scoped>
button {
	font-family: 'RobotoRegular';
	border: 0;
	color: $font-light;
	font-weight: 500;
	letter-spacing: 1px;
	background-color: $primary-state;
	font-size: 15px;
	display: inline-block;
	justify-content: center;
	align-items: center;
	height: 48px;
	width: 100%;
	border-radius: 4px;

	@media (min-width: $breakpoint-mid) {
		font-size: 16px;
	}

	@media (any-hover: hover) {
		&:hover {
			cursor: pointer;
			background-color: $hover-state;
		}
	}

	&.selected {
		background-color: $outlined-state;
		border: 1px solid $tax-button;
		color: $font-dark;

		svg {
			display: none;
		}

		.amount {
			display: inline !important;
			color: $questionnaire-color;
		}

		.button-content-wrapper {
			display: flex;
			justify-content: space-between;
		}
	}
}
</style>
